import { useContext } from 'react';
import { CurrentUserContext } from 'src/contexts/CurrentUserProvider';

const useCurrentUser = () => {
  return useContext(CurrentUserContext)
};

export default useCurrentUser;
